import { Outlet } from "react-router-dom";
import MobileNav from "@/components/navigation/MobileNav";
import Header from "@/components/navigation/Header";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePageTitle } from "@/hooks/usePageTitle";
import SellerSubscriptionBanner from "@/components/seller/SellerSubscriptionBanner";
import { PaymentFailedBanner } from "@/components/seller/PaymentFailedBanner";
import { useAuth } from "@/contexts/AuthContext";
import { usePushNotifications } from "@/hooks/usePushNotifications";

const DashboardLayout = () => {
  const isMobile = useIsMobile();
  const pageTitle = usePageTitle();
  const { user } = useAuth();
  
  // Initialize push notifications for sellers
  usePushNotifications({
    userId: user?.id || null,
    userType: 'seller',
    enabled: true
  });
  return (
    <div className="min-h-screen flex flex-col">
      <PaymentFailedBanner />
      <SellerSubscriptionBanner />
      <Header title={pageTitle} />
      
      <main className="flex-grow pb-[calc(3.5rem+env(safe-area-inset-bottom))] md:pb-8 px-2 sm:px-4 md:px-6 2xl:px-8 max-w-7xl mx-auto w-full">
        <div className="py-4">
          <Outlet />
        </div>
      </main>
      
      {isMobile && <MobileNav />}
    </div>
  );
};

export default DashboardLayout;
